export const configContents = ({ state: { langStrings } }) => [
  { isSpin: true,
    id: 'adsk-page-title',
  },
  {
    description: langStrings
      ? langStrings.signIn.gatheringInfo
      : 'Gathering your account information',

    style: { fontSize: '26px', fontWeight: 400, color: '#333' },
    paragraphStyle: {
      textAlign: 'center',
      marginBottom: '30px',
    },
  },
  {
    description: langStrings
      ? langStrings.signIn.justAMoment
      : 'Just a moment ...',

    style: { fontSize: '14px', color: '#666' },
    paragraphStyle: { textAlign: 'center' },
  },
];

export default {
  configContents,
};
